import styled from 'styled-components';

export const StyledButtonsContainer = styled.div`
  height: 50px;
  width: 260px;
  padding: 10px;
  display: flex;
  justify-content: space-between;
`;
